var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Display'),_c('div',{staticClass:"main-content"},[_c('Business'),_c('About')],1),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }